/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:6d3e0aff-b157-4e74-b2d0-29baf243819b",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_lJC5t1GRs",
    "aws_user_pools_web_client_id": "7pni0e8t1dvq029b50ej4dqrha",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://mydtjijxfzbbteq6dzloo3mpgu.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-ybxkdojr7nfpjikatyebqkmaty",
    "aws_user_files_s3_bucket": "s3collegecamps144439-production",
    "aws_user_files_s3_bucket_region": "us-east-2"
};


export default awsmobile;
